// extracted by mini-css-extract-plugin
module.exports = {"CardDocSection":"CardDocSection_CardDocSection__3KKeB"};